// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon{vertical-align:middle}.todos-title{padding:20px;font-size:18px;white-space:nowrap}.todos-title .inner{color:#000;border-color:#000;border-bottom-style:solid;padding-bottom:8px;font-weight:bold}", ""]);
// Exports
module.exports = exports;
